<div [ngClass]="css">
    <ng-content></ng-content>
</div>
